import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { login } from "store/api";
import Cookies from "js-cookie";
import Success from "components/Success";

function SignIn () {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });
  // const [rememberMe, setRememberMe] = useState(false);
  // const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const handleChange = e => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };
  const handleSubmit = async e => {
    e?.preventDefault();
    const response = await login(loginData);
    if (response?.success) {
      Cookies.set("adminToken", response?.data?.accessToken);
      setMsg("Login successful! Welcome back.");
      setTimeout(() => {
        navigate("/dashboard");
      }, [3000]);
      setSuccess(true);
    } else if (response?.response?.data) {
      setMsg(response?.response?.data?.message);
      setSuccess(false);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant='gradient'
          bgColor='success'
          borderRadius='lg'
          coloredShadow='info'
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign='center'
        >
          <MDTypography variant='h4' fontWeight='medium' color='white' mt={1}>
            Sign in
          </MDTypography>
          {/* <Grid container spacing={3} justifyContent='center' sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href='#' variant='body1' color='white'>
                <FacebookIcon color='inherit' />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href='#' variant='body1' color='white'>
                <GitHubIcon color='inherit' />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href='#' variant='body1' color='white'>
                <GoogleIcon color='inherit' />
              </MDTypography>
            </Grid>
          </Grid> */}
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component='form' role='form' onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type='text'
                name='username'
                label='Username'
                onChange={handleChange}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type='password'
                name='password'
                label='Password'
                onChange={handleChange}
                fullWidth
              />
            </MDBox>
            {/* <MDBox display='flex' alignItems='center' ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant='button'
                fontWeight='regular'
                color='text'
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton type='submit' variant='gradient' color='light' fullWidth>
                sign in
              </MDButton>
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign='center'>
              <MDTypography variant='button' color='text'>
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to='/authentication/sign-up'
                  variant='button'
                  color='info'
                  fontWeight='medium'
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </BasicLayout>
  );
}

export default SignIn;
